import { useContext, memo } from 'react';
import { InstructionField } from '@scale/shared/types/params/textcollection';
import { ChatTaskContext } from 'react-scale/components/scalers/tasks/ThreadedInteraction/contexts/ChatTaskContext';
import FieldHeader from 'react-scale/components/scalers/tasks/textcollection/SimpleTextCollection/FieldHeader';
import { ChatMarkdown } from '../../../ThreadedInteraction/components/ChatMarkdown';
import { ChatMessageDisplayConfig } from '../../../ThreadedInteraction/hooks/useConfigureChatMessageDisplay';
import { useIsRealCustomerAudit } from 'react-scale/components/scalers/tasks/Chat/hooks/ChatStore.hooks';
import { useShowContributorInstructionsStore } from 'react-scale/components/scalers/tasks/ThreadedInteraction/hooks/useShowContributorInstructionsStore';
import useUnleashFeatureFlag from 'react-scale/hooks/useUnleashFeatureFlag';
interface SimpleInstructionFieldProps {
  field: InstructionField;
  chatMessageDisplayConfig?: ChatMessageDisplayConfig;
}

const SimpleInstructionField = ({
  field,
  chatMessageDisplayConfig,
}: SimpleInstructionFieldProps) => {
  const taskContext = useContext(ChatTaskContext);
  const isRealCustomerAudit = useIsRealCustomerAudit();
  const shouldAlwaysShowContributorInstructions = useUnleashFeatureFlag(
    'audit-always-show-contributor-instructions',
    { projectId: taskContext.projectId },
    false,
  );
  const customerAuditShowInstructions = useShowContributorInstructionsStore(
    state => state.customerAuditShowInstructions,
  );

  if (
    isRealCustomerAudit &&
    !customerAuditShowInstructions &&
    !shouldAlwaysShowContributorInstructions
  ) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      {field.title && <FieldHeader title={field.title} />}
      <div className="w-full whitespace-normal">
        <ChatMarkdown
          className="text-sm"
          markdown={field.instruction ?? ''}
          enableMath={chatMessageDisplayConfig?.markdownConfig.enableMathPlugin}
          enableSingleDollarTextMath={
            chatMessageDisplayConfig?.markdownConfig.enableSingleDollarTextMath
          }
          enableHtml={taskContext.htmlMarkdownConfig?.enableResponsePreviews}
          enableSoftBreaks={taskContext.generalMarkdownConfig?.enableSoftLineBreaks}
          enableExecutableCodeBlocks={
            taskContext.codingConfig?.enableExecutableCodeMarkdown ??
            taskContext.generalMarkdownConfig?.enableExecutableCodeMarkdown
          }
        />
      </div>
    </div>
  );
};

export default memo(SimpleInstructionField);
